import React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import {
  StyledOverlay,
  StyledContent,
  CloseButton,
  DialogHeader,
  DialogFooter,
  DialogTitleStyled,
  DialogDescriptionStyled,
  CloseIcon,
} from './style'

// Root wrapper
export function Dialog(props) {
  return <DialogPrimitive.Root {...props} />
}

export function DialogTrigger(props) {
  return <DialogPrimitive.Trigger {...props} />
}

export function DialogOverlay(props) {
  return <StyledOverlay {...props} />
}

export const DialogContent = React.forwardRef(
  ({ children, showCloseButton = true, ...props }, ref) => {
    return (
      <>
        <DialogOverlay />
        <StyledContent ref={ref} {...props}>
          {children}
          {showCloseButton && (
            <CloseButton aria-label='Close'>
              <CloseIcon size={16} strokeWidth={2} />
            </CloseButton>
          )}
        </StyledContent>
      </>
    )
  }
)

export function DialogClose(props) {
  return <DialogPrimitive.Close {...props} />
}

export { DialogHeader, DialogFooter }
export const DialogTitle = DialogTitleStyled
export const DialogDescription = DialogDescriptionStyled 